/**
 * useBodyScrollLock hook
 *
 * Locks body and html scroll while the component is mounted.
 * Useful for pages that manage their own internal scroll region
 * (e.g., the moderation card grid) and need to prevent the outer
 * page from scrolling.
 *
 * Restores previous overflow values on unmount.
 */

import { useEffect } from 'react';

/**
 * Locks the body and document element overflow to 'hidden' on mount
 * and restores previous values on unmount.
 */
export function useBodyScrollLock(): void {
  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);
}
